var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.66602 7.33325H4.66602C3.56145 7.33325 2.66602 8.22868 2.66602 9.33325V10.6666C2.66602 11.7712 3.56145 12.6666 4.66602 12.6666H11.3327C12.4373 12.6666 13.3327 11.7712 13.3327 10.6666V9.33325C13.3327 8.22868 12.4373 7.33325 11.3327 7.33325H10.3327M7.99935 8.66659V3.33325M7.99935 3.33325L6.33268 4.99992M7.99935 3.33325L9.66602 4.99992",
    stroke: "#0D0D12",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddImage);
export default __webpack_public_path__ + "static/media/AddImage.f9e963b4aa4dcc4b46a1ab53ec45d887.svg";
export { ForwardRef as ReactComponent };